import api from './api';
import type { SignedUploadUrlResponse } from '../types';

/**
 * Upload a file directly to Supabase Storage using a signed URL from our API.
 * Returns the public URL of the uploaded file.
 */
export async function uploadFile(file: File, folder: string): Promise<string> {
  // 1. Get signed upload URL from our API
  const response = await api.post<SignedUploadUrlResponse>('/uploads/signed-url', {
    fileName: file.name,
    folder,
  });
  const signedUrl = response.data;

  // 2. Upload directly to Supabase Storage
  const uploadRes = await fetch(signedUrl.uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type || signedUrl.contentType,
    },
    body: file,
  });

  if (!uploadRes.ok) {
    const body = await uploadRes.text().catch(() => '');
    throw new Error(`Upload failed: ${uploadRes.status} ${uploadRes.statusText}${body ? ` — ${body}` : ''}`);
  }

  return signedUrl.publicUrl;
}
